import { Navigate, useLocation } from 'react-router-dom';
import { useCurrentUser } from './CurrentUserContext.jsx';
import { rbac } from '@dha-nexus/shared';

export function RequireRoute({ roles, children, allowMustChangePassword = false }) {
  const { roles: actorRoles, loading, user, auth } = useCurrentUser();
  const location = useLocation();
  if (loading) return <div className="empty-state">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (
    auth?.mustChangePassword &&
    !allowMustChangePassword &&
    location.pathname !== '/change-password'
  ) {
    return <Navigate to="/change-password" replace />;
  }
  if (roles && !rbac.hasAnyRole(actorRoles, roles))
    return <Navigate to="/not-authorized" replace />;
  return children;
}

export function PermissionGate({ roles, children, fallback = null }) {
  const { roles: actorRoles } = useCurrentUser();
  if (!roles || rbac.hasAnyRole(actorRoles, roles)) return children;
  return fallback;
}
